import { authHTTP } from "./axios.service";
import { HandleFilters } from "@/services/filters.service";
import store from "@/store";

class CoursesService {

  list(filters) {
    // filters: A dict of key:value pairs
    let page_size = store.getters["core/pageSize"];
    let queryString = HandleFilters(filters, page_size);
    return authHTTP.get("courses/" + queryString);
  }

  create(payload) {
    // payload: A dict containing { candidate_id, course_id, start_date }
    return authHTTP.post("courses/", payload);
  }

  get(id) {
    // id: The id (pk) of the course.
    return authHTTP.get("courses/" + id + "/");
  }

  getTemplates() {
    return authHTTP.get("courses/templates/");
  }

  completeCourse(id) {
    let payload = { is_complete: true }
    return authHTTP.patch("courses/" + id + "/", payload);
  }

  updateCourse(id, payload) {
    return authHTTP.patch("courses/" + id + "/", payload);
  }

  getCourseCertificate(id) {
    return authHTTP.get("courses/" + id + "/download/");
  }

  getCourseCertificateEmail(id) {
    return authHTTP.get("courses/" + id + "/email/");
  }

}

export default new CoursesService;
